export default __webpack_public_path__ + "static/total-retail-loss-028d034012989cb032e65a57f470a051.jpg";